import { Bell, CaretDown, MagnifyingGlass, SignOut, User } from '@phosphor-icons/react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { Link } from 'react-router-dom';
import { Avatar, Divider, Input, Kbd } from '@/components/ui';
import { useAuth } from '@/lib/hooks/useAuth';

export function Topbar() {
  const { user, signOut } = useAuth();

  return (
    <header className="sticky top-0 z-10 flex h-16 shrink-0 items-center justify-between border-b border-line bg-board/85 px-8 backdrop-blur">
      <div className="w-64">
        <Input
          type="search"
          placeholder="Search pages, settings..."
          leadingIcon={<MagnifyingGlass size={16} />}
          trailingAdornment={
            <>
              <Kbd>⌘</Kbd>
              <Kbd>K</Kbd>
            </>
          }
        />
      </div>

      <div className="flex items-center gap-5">
        <button
          type="button"
          className="relative text-ink-muted transition-colors hover:text-ink"
          aria-label="Notifications"
        >
          <Bell size={20} />
          <span
            aria-hidden
            className="absolute right-0 top-0 h-2 w-2 translate-x-0.5 -translate-y-0.5 rounded-full border border-board bg-ink"
          />
        </button>
        <Divider orientation="vertical" />
        <DropdownMenu.Root>
          <DropdownMenu.Trigger asChild>
            <button
              type="button"
              className="group flex items-center gap-2 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-ink/20"
              aria-label="Account menu"
            >
              <Avatar
                src={user?.avatarUrl ?? undefined}
                alt={user?.name ?? 'You'}
                size="sm"
              />
              <CaretDown
                size={12}
                className="text-ink-faint transition-colors group-hover:text-ink group-data-[state=open]:text-ink"
              />
            </button>
          </DropdownMenu.Trigger>
          <DropdownMenu.Portal>
            <DropdownMenu.Content
              align="end"
              sideOffset={10}
              className="z-50 w-56 rounded-xl border border-line bg-board p-1.5 shadow-float"
            >
              <div className="px-2.5 py-2">
                <p className="truncate text-sm font-medium text-ink">
                  {user?.name ?? 'You'}
                </p>
                <p className="truncate text-[11px] text-ink-faint">
                  {user?.email ?? ''}
                </p>
              </div>
              <DropdownMenu.Separator className="my-1 h-px bg-line" />
              <DropdownMenu.Item asChild>
                <Link
                  to="/app/settings"
                  className="flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-sm text-ink outline-none data-[highlighted]:bg-rail"
                >
                  <User size={14} /> Account settings
                </Link>
              </DropdownMenu.Item>
              <DropdownMenu.Separator className="my-1 h-px bg-line" />
              <DropdownMenu.Item
                onSelect={() => signOut()}
                className="flex cursor-pointer items-center gap-2 rounded-md px-2.5 py-2 text-sm text-ink outline-none data-[highlighted]:bg-rail"
              >
                <SignOut size={14} /> Sign out
              </DropdownMenu.Item>
            </DropdownMenu.Content>
          </DropdownMenu.Portal>
        </DropdownMenu.Root>
      </div>
    </header>
  );
}
